import React from 'react';
import { Row, Col } from 'reactstrap';

import { Title } from 'components/typography';

import { updatesIntro } from './scss/UpdatesIntro.module.scss';

const UpdatesIntro = () => {
  return (
    <Row className={updatesIntro}>
      <Col md="6">
        <Title
          size="xl"
          value={
            <>
              For ordinary people, <br className="d-none d-md-block" />
              attempting the extraordinary, <br className="d-none d-md-block" />
              just like us
            </>
          }
        />
      </Col>
      <Col md="6">
        <p>
          The AFEX Blog has three key sections: Impact, Learning and Culture.
          The first to share what we do, the next to share what we know and the
          last to share who we are. You can also check our Press Release section
          to get the latest news about the Exchange and our Events section for a
          deep dive into our fun and insightful meet-ups.
        </p>
      </Col>
    </Row>
  );
};

export default UpdatesIntro;
